import type { Dict } from "../en";

export const mem: Dict["mem"] = {
  // ---- dates and shared words ----
  todayAt: "hôm nay {time}",
  dayName: "{weekday}, {day} {month}",
  since: "Từ {date}",
  until: "Đến {date}",
  anyTime: "Mọi lúc",
  all: "Tất cả",
  company: "Công ty",
  personal: "Cá nhân",
  aTeam: "Một nhóm",
  onePerson: "Một người",
  onlyName: "Chỉ {name}",
  anAutomation: "Một tác vụ tự động",
  showMore: "Xem thêm",
  shownOf: "{shown} trên {total} {what}",
  openDetails: "{what}, mở chi tiết",
  facts: "dữ kiện",
  lessons: "bài học",
  items: "mục",
  ratings: "lượt đánh giá",
  archive: "Lưu trữ",
  pinned: "Đã ghim",
  statusLabel: "Trạng thái:",
  personLabel: "Người:",
  everyone: "Mọi người",

  // ---- the memory page's words ----
  weightTitle: "Trọng số: {w}",
  weightRetired: "đã ngừng áp dụng",
  weightWeak: "yếu · thêm một 👎 nữa là ngừng áp dụng",
  weightFading: "đang giảm",
  weightNew: "mới",
  weightSteady: "ổn định",
  weightStrong: "mạnh",
  notUsedYet: "chưa dùng lần nào",
  applied_one: "đã áp dụng 1 lần",
  applied_other: "đã áp dụng {n} lần",
  fromOwnersDown: "từ 👎 của {name}",
  fromDownWithNote: "từ một 👎 kèm ghi chú",
  toldBy: "{name} dặn trong cuộc trò chuyện",
  toldInChat: "được dặn trong một cuộc trò chuyện",
  agreedByTeam: "được 2 thành viên {team} đồng ý",
  agreedBy2: "được 2 thành viên đồng ý",
  fromUpVotes: "từ các lượt 👍",
  addedByAdmin: "do quản trị viên thêm",
  fromSource: "từ {source}",
  meterLabel: "{used} trên {limit} token",
  confHigh: "Cao",
  confMedium: "Trung bình",
  confLow: "Thấp",
  fairlySure: "khá chắc chắn",
  fairlyUnsure: "chưa chắc lắm",
  unsure: "không chắc",
  srcChat: "Nói trong một cuộc trò chuyện",
  srcChannel: "Nghe được trong một kênh",
  srcEmail: "Nói trong một email",
  srcTool: "Kiểm tra trong một công cụ",
  srcAdmin: "Do quản trị viên thêm hoặc sửa",
  srcSeed: "Thiết lập cùng không gian làm việc",
  srcImport: "Nhập từ Vantage cũ",
  usedInAnswers_one: "dùng trong {n} câu trả lời",
  usedInAnswers_other: "dùng trong {n} câu trả lời",
  stCurrent: "Hiện hành",
  stScheduled: "Đã lên lịch",
  stExpired: "Đã hết hạn",
  stReplaced: "Đã thay thế",
  stArchived: "Đã lưu trữ",
  wCurrent: "hiện hành",
  wScheduled: "đã lên lịch",
  wExpired: "đã hết hạn",
  wReplaced: "đã thay thế",
  wArchived: "đã lưu trữ",

  // ---- Memory page and tabs ----
  memory: "Bộ nhớ",
  memorySub:
    "Chỉ dành cho quản trị viên. Dữ kiện của công ty dùng cho câu trả lời của mọi người; dữ kiện của nhóm chỉ ở trong nhóm đó.",
  tabFacts: "Dữ kiện",
  tabLessons: "Bài học",
  tabBriefing: "Bản tóm tắt",
  tabReview: "Cần duyệt",
  waitingForYou: "{n} mục đang chờ bạn",

  // ---- Add a fact ----
  add: "Thêm",
  aFact: "dữ kiện",
  addFact: "Thêm dữ kiện",
  savedForTeam: "Đã lưu cho {team}.",
  theTeam: "nhóm",
  savedForCompany: "Đã lưu cho cả công ty.",
  couldntSaveFact: "Không lưu được dữ kiện.",
  statement: "Nội dung",
  phStatement: "Staging được deploy vào thứ Năm",
  about: "Về",
  topic: "Chủ đề",
  phTopic: "ngày deploy",
  belongsTo: "Thuộc về",
  companyEveryone: "Công ty (mọi người)",
  validUntil: "Hiệu lực đến",
  pinnedHelpNew: "Luôn có trong bản tóm tắt, kể cả khi đã đầy.",
  replaceHelp:
    "Nếu trùng Về và Chủ đề với một dữ kiện hiện hành, dữ kiện đó sẽ được thay thế; bản cũ vẫn nằm trong lịch sử. Còn lại sẽ là dữ kiện mới.",
  saveFact: "Lưu dữ kiện",

  // ---- Facts ----
  startsOn: "bắt đầu {date}",
  expiredOn: "hết hạn {date}",
  dueToday: "hôm nay",
  dueTomorrow: "ngày mai",
  daysLeft_one: "còn {n} ngày",
  daysLeft_other: "còn {n} ngày",
  untilDate: "đến {date}",
  aliasNoEnd: "bí danh · không có ngày kết thúc",
  noEndDateLower: "không có ngày kết thúc",
  pinnedAlways: "Đã ghim: luôn có trong bản tóm tắt",
  recentlyExpired: "Mới hết hạn, giữ lại làm lịch sử",
  nothingExpired: "Chưa có gì hết hạn.",
  showAllExpired: "Xem tất cả {n} dữ kiện đã hết hạn",
  searchMemoryPh: "Tìm trong bộ nhớ…",
  searchMemory: "Tìm trong bộ nhớ",
  theFacts: "các dữ kiện",
  nothingMatches: "Không có kết quả phù hợp",
  noFactsYet: "Chưa có dữ kiện nào",
  searchHelp: "Tìm theo nội dung, tên và ý nghĩa, bằng cả tiếng Anh và tiếng Việt.",
  factsEmptyHelp:
    "Vantage ghi nhớ những gì mọi người nói trong các cuộc trò chuyện và các kênh đang lắng nghe.",
  best50: "50 kết quả phù hợp nhất",
  nMatches: "{n} kết quả",
  forQuery: "cho “{q}”",

  // ---- the fact's panel ----
  verCurrent: "Hiện hành · từ {date} · {source}",
  verScheduled: "Đã lên lịch · từ {date} · {source}",
  later: "sau này",
  sinceDate: "từ {date}",
  savedNewVersion: "Đã lưu thành phiên bản mới. Bản cũ vẫn nằm trong lịch sử.",
  couldntSave: "Không lưu được.",
  pinnedToast: "Đã ghim: dữ kiện luôn có trong bản tóm tắt.",
  unpinned: "Đã bỏ ghim.",
  factDetails: "Chi tiết dữ kiện",
  fact: "Dữ kiện",
  thisFact: "dữ kiện này",
  removeEndDate: "Bỏ ngày kết thúc",
  noEndDate: "Không có ngày kết thúc",
  pinnedHelp: "Dữ kiện đã ghim luôn có trong bản tóm tắt, kể cả khi đã đầy.",
  whereFrom: "Nguồn gốc",
  source: "Nguồn",
  how: "Cách ghi nhận",
  confidence: "Độ tin cậy",
  usedInLabel: "Được dùng trong",
  answers_one: "{n} câu trả lời",
  answers_other: "{n} câu trả lời",
  noAnswersYet: "Chưa có câu trả lời nào",
  status: "Trạng thái",
  statusSince: "{status} · từ {date}",
  historyOfTopic: "Lịch sử của chủ đề này",
  onlyReplaced:
    "Chỉ “{about} · {topic}” bị thay thế. Các dữ kiện khác về {about} không bao giờ bị động đến.",
  archiveFactQ: "Lưu trữ dữ kiện này?",
  archiveFactBody: "Vantage sẽ ngừng dùng “{statement}”. Dữ kiện vẫn nằm trong lịch sử của chủ đề.",
  archivedFact: "Đã lưu trữ. Vantage không dùng dữ kiện này nữa.",

  // ---- Lessons ----
  makeItTeams: "Chuyển cho {team}",
  makeItCompanys: "Chuyển cho cả công ty",
  nowCompanyLesson: "Giờ đây là bài học của cả công ty.",
  nowTeamLesson: "Giờ đây là bài học của {team}.",
  lessonSaved: "Đã lưu bài học.",
  lessonText: "Nội dung bài học",
  keepDoing: "tiếp tục làm",
  archivedLesson: "Đã lưu trữ. Vantage ngừng áp dụng bài học này.",
  restored: "Đã khôi phục.",
  restore: "Khôi phục",
  automations: "Tự động hóa",
  retired: "Ngừng áp dụng",
  searchLessonsPh: "Tìm bài học…",
  searchLessons: "Tìm bài học",
  lessonsNote:
    "Bài học là cách chúng ta làm việc: thói quen và định dạng Vantage học được từ 👍 và 👎. Dữ kiện là những điều đúng. Với mỗi người, bài học riêng của họ được ưu tiên hơn bài học của nhóm. Các 👍 sau này làm bài học mạnh lên; 👎 lặp lại làm nó yếu đi cho đến khi ngừng áp dụng.",
  theLessons: "các bài học",
  noLessonsYet: "Chưa có bài học nào",
  lessonsEmptyHelp:
    "Một 👎 kèm ghi chú sẽ dạy ngay cho chính người đưa ra; hai đồng đội cùng đồng ý thì nó thành bài học của nhóm.",

  // ---- Briefing ----
  holdsInMind: "Những gì Vantage luôn ghi nhớ",
  holdsInMindIn: "Những gì Vantage luôn ghi nhớ trong {place}",
  loadedEveryTurn:
    "Được nạp ở đầu mỗi lượt, trước mọi tìm kiếm. Được dựng lại mỗi khi bộ nhớ thay đổi.",
  viewingAs: "Xem với vai trò:",
  teamsChannel: "Kênh của một nhóm",
  teamMember: "Thành viên {team}",
  personsOwnChat: "Cuộc trò chuyện riêng của một người",
  theBriefing: "bản tóm tắt",
  size: "Dung lượng",
  briefingSize: "Dung lượng bản tóm tắt",
  nSections: "{n} phần",
  everythingFits: "vừa đủ tất cả",
  leftOut_one: "{n} dữ kiện bị lược bớt cho vừa ({ids}); Vantage vẫn tìm được chúng khi tìm kiếm",
  leftOut_other: "{n} dữ kiện bị lược bớt cho vừa ({ids}); Vantage vẫn tìm được chúng khi tìm kiếm",
  showBySection: "Xem theo phần",
  showPlain: "Xem dạng văn bản thuần",
  nothingHereYet: "Chưa có gì ở đây",
  briefingFoot:
    "Ở đây chỉ hiện những gì người xem này được phép đọc: dữ kiện của nhóm khác không bao giờ xuất hiện. Muốn thay đổi những gì Vantage biết, hãy sửa các dữ kiện; phần này sẽ cập nhật theo.",

  // ---- Review ----
  aLesson: "Một bài học",
  foundWhen: "phát hiện {when}",
  wouldReplace: "Sẽ thay thế: “{current}”",
  dismissed: "Đã bỏ qua.",
  saved: "Đã lưu.",
  reviewNote: "Vantage chưa chắc những mục này thuộc về đâu, nên hỏi bạn thay vì tự đoán.",
  theReviewQueue: "danh sách cần duyệt",
  nothingToReview: "Không có gì cần duyệt",
  reviewEmptyHelp: "Khi Vantage chưa chắc một điều thuộc về đâu, nó sẽ chờ bạn ở đây.",

  // ---- the date range ----
  today: "Hôm nay",
  last7: "7 ngày qua",
  last30: "30 ngày qua",
  datesFor: "Thời gian: {label}",
  dates: "Thời gian",
  from: "Từ ngày",
  to: "Đến ngày",

  // ---- Feedback ----
  feedback: "Phản hồi",
  feedbackSub:
    "Chỉ dành cho quản trị viên. Ai đánh giá gì chỉ người đánh giá và quản trị viên được thấy.",
  good: "Tốt",
  needsWork: "Cần cải thiện",
  flagged: "Đã gắn cờ",
  reasonLabel: "Lý do:",
  any: "Bất kỳ",
  teamLabel: "Nhóm:",
  ratingsCount_one: "{n} lượt đánh giá",
  ratingsCount_other: "{n} lượt đánh giá",
  newestFirst: "mới nhất trước",
  theFeedback: "phản hồi",
  noRatingsMatch: "Không có lượt đánh giá nào khớp với bộ lọc.",
  newestCap: "Đây là {n} lượt mới nhất: chọn ngày để xem các lượt cũ hơn.",
  flagsFoot:
    "Cờ chỉ để đánh dấu phản hồi: người xây dựng Vantage sẽ biến chúng thành bài kiểm thử và bản sửa lỗi, với tên và chi tiết đã được viết lại. Không có gì ở đây tự thay đổi Vantage.",
  flagTestChip: "Cần kiểm thử",
  flagTestRemove: "Bỏ cờ cần kiểm thử",
  flagTestAdd: "Gắn cờ: cần kiểm thử",
  flagBugChip: "Lỗi",
  flagBugRemove: "Bỏ cờ lỗi",
  flagBugAdd: "Gắn cờ: lỗi",
  them: "họ",
  justName: "Chỉ {name}",
  lessonForAlone: "Bài học riêng cho {name}.",
  lessonForNow: "Giờ đã là bài học cho {where}.",
  couldntMakeLesson: "Không tạo được bài học.",
  makeLesson: "Tạo bài học",
  makeLessonFor: "Tạo bài học cho",
  theLesson: "Bài học",
  phLesson: "Khi liệt kê ticket, ghi kèm người phụ trách",
  lessonRule: "Một quy tắc ngắn: không ghi tên người, ticket, khách hàng hay con số.",
  makeTheLesson: "Tạo bài học",
  couldntSaveFlag: "Không lưu được cờ.",
  someone: "ai đó",
  goodAnswer: "Câu trả lời tốt",
  noNote: "Không có ghi chú",
  noText: "(không có nội dung)",
  openTrace: "Xem quá trình xử lý",

  // ---- the scorecard ----
  ofN: "trên {n}",
  laneFast: "Nhanh",
  laneDeep: "Sâu",
  laneAutomation: "Tự động hóa",
  upRate: "Tỷ lệ 👍",
  ofRated: "{up} trên {rated} lượt đánh giá",
  slowAnswers: "câu trả lời chậm (> 10 giây)",
  aOfB: "{a} trên {b}",
  costPerAnswer: "chi phí mỗi câu trả lời",
  noAnswersYetLower: "chưa có câu trả lời nào",
  ofAnswersRated: "câu trả lời được đánh giá",
  personsLesson: "Bài học của {name}",
  teamsLesson: "Bài học của {team}",
  theTeamCap: "nhóm",
  companyLesson: "Bài học của công ty",
  automationsLesson: "Bài học của tác vụ tự động",
  lessonRetired: "Bài học đã ngừng áp dụng",
  stateLesson: "Bài học {state}",
  voteOnly: "Chỉ bình chọn",
  raisedWeight: "đã tăng trọng số của các bài học mà câu trả lời này dùng",
  slowNotCounted: "câu trả lời chậm không bị tính vào các bài học nó đã dùng",
  loweredWeight: "đã giảm trọng số của các bài học mà câu trả lời này dùng",
  noLesson: "Không có bài học",
  noteNoRule:
    "ghi chú chưa thành quy tắc chung (có thể nó sửa một dữ kiện, hoặc vẫn đang được xem xét)",
  aChannel: "một kênh",
  dm: "Tin nhắn riêng",
  chatWithVantage: "Trò chuyện với Vantage",
  inbox: "Hộp thư",
  upRateByTeam: "Tỷ lệ 👍 theo nhóm",
  noRatingsYet: "Chưa có lượt đánh giá nào.",
  upRateByLane: "Tỷ lệ 👍 theo chế độ",
  topDownReasons: "Lý do 👎 hàng đầu",
  noDownInDates: "Không có 👎 nào trong khoảng ngày này.",
  downsInAll: "Tổng cộng {n} 👎. Một 👎 có thể có nhiều lý do.",
  scorecard: "Bảng điểm",
  followsDates: "theo khoảng ngày ở trên",
  last7Unless: "7 ngày qua, trừ khi bạn chọn ngày",
  theScorecard: "bảng điểm",

  // ---- the Audit log ----
  allTools: "Tất cả công cụ",
  plRedmineUpdate: "Đã cập nhật {n} ticket trong Redmine",
  plRedmineCreate: "Đã tạo {n} ticket trong Redmine",
  plRedmineNote: "Đã thêm ghi chú vào {n} ticket trong Redmine",
  plRedmineDelete: "Đã xóa {n} ticket trong Redmine",
  plGithubComment: "Đã bình luận vào {n} mục trên GitHub",
  plGithubCreate: "Đã mở {n} issue trên GitHub",
  plGithubUpdate: "Đã cập nhật {n} issue trên GitHub",
  plOutlineUpdate: "Đã cập nhật {n} tài liệu trong Outline",
  plOutlineDelete: "Đã xóa {n} tài liệu khỏi Outline",
  plOutlineArchive: "Đã lưu trữ {n} tài liệu trong Outline",
  moreChanges: "và {n} thay đổi khác",
  anUndo: "Một lần hoàn tác",
  undone: "Đã hoàn tác",
  undoneBy: "{name} đã hoàn tác",
  undoAvailable: "Có thể hoàn tác",
  changedSince: "Đã có thay đổi sau đó: không hoàn tác được",
  undoExpired: "Đã hết hạn hoàn tác",
  noUndo: "Không thể hoàn tác",
  undoOfEarlier: "Hoàn tác một thay đổi trước đó",
  partlyUndoneChanged: "Đã hoàn tác một phần: có thay đổi sau đó",
  partlyUndone: "Đã hoàn tác một phần",
  undoWindowEnded: "Hết hạn hoàn tác lúc {when}",
  availableUntil: "Có thể hoàn tác đến {when}",
  viaWeb: "web",
  viaEmail: "email",
  viaAutomation: "tác vụ tự động",
  viaAdmin: "màn hình quản trị",
  viaUndo: "hoàn tác",
  viaSystem: "Vantage tự thực hiện",
  nobody: "không ai",
  nothing: "không có gì",
  anAdminScreen: "một màn hình quản trị",
  anAutomationLower: "một tác vụ tự động",
  noConversation: "không có cuộc trò chuyện",
  aConversation: "một cuộc trò chuyện",
  inChannel: "trong #{name}",
  aDm: "một tin nhắn riêng",
  theInbox: "Hộp thư",
  chatWithVantageLower: "trò chuyện với Vantage",
  undidN: "Đã hoàn tác {n}.",
  undoneDot: "Đã hoàn tác.",
  undidChanges: "Đã hoàn tác {n} thay đổi.",
  undoAll: "Hoàn tác tất cả",
  undoAllQ: "Hoàn tác cả {n} thay đổi?",
  undoAllBody:
    "Từng thay đổi trong {n} thay đổi sẽ được đưa về như cũ, ở những chỗ vẫn còn làm được.",
  undoAllN: "Hoàn tác cả {n}",
  nChanges: "{n} thay đổi",
  changeDetails: "Chi tiết thay đổi",
  change: "Thay đổi",
  whatHappened: "Điều gì đã xảy ra",
  askedBy: "Người yêu cầu",
  openMessage: "Mở tin nhắn",
  when: "Thời điểm",
  via: "Qua",
  removed: "{value} (đã xóa)",
  openIn: "Mở trong {tool}",
  undoThisOne: "Hoàn tác mục này",
  nameOrAdminCanUndo: "{name} hoặc quản trị viên có thể hoàn tác",
  anAdminCanUndo: "Quản trị viên có thể hoàn tác",
  auditLog: "Nhật ký thay đổi",
  auditSub:
    "Chỉ dành cho quản trị viên. Mọi thay đổi Vantage đã thực hiện, ai yêu cầu, và có hoàn tác được không.",
  tool: "Công cụ",
  theAuditLog: "nhật ký thay đổi",
  nothingHere: "Không có gì ở đây",
  noChangesMatch: "Không có thay đổi nào khớp với bộ lọc.",
  loadOlder: "Tải cũ hơn",
  newestFirstCap: "Mới nhất trước",
  thatsEverything: "đã hết",
};
